module.exports = __webpack_public_path__ + "static/media/talktome.6f92b0a9.png";